import React from 'react'
import Manager from '../../public/components/Manager'
import MaterialDiv from './MaterialDiv'
import MaterialCategoryDiv from './MaterialCategoryDiv'
Ext.require('Ext.Toast')


const config = {

    buttons: [
        {
            icon: 'plus', text: '添加...', handler: ({ showDetail, refreshPage, category: { id: fatherID } = {} }) =>
                Tyan.pubForm.showDialog('物料', props => <MaterialDiv {...props} onSave={refreshPage} id={0} fatherID={fatherID} />, console.log(fatherID))
        },
        { text: '导入...', btnName: '提交', handler: ({ refreshPage }) => Tyan.pubForm.showImport('ImportMaterial', '物料导入', (data) => refreshPage && refreshPage()) },
    ],
    columns: [
        { _text: '物料代码', field: 'MaterialNumber', search: true, minWidth: 150/* , tools: tipTools */ },
        { _text: '物料名称', field: 'Name', search: true, minWidth: 150, flex: 1, },
        { _text: '单位', field: 'Unit', minWidth: 150, flex: 1, },
        { _text: '资产属性', field: 'AssetAttribute', filter: true, minWidth: 150, flex: 1, },
        { _text: '所属分类', field: 'MaterialCategory.Name', minWidth: 150, flex: 1, },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) =>
        Tyan.pubForm.showDialog('物料', props => <MaterialDiv {...props} id={data.id} onSave={refreshPage} />),
    categories: {
        onDoubleTap: (that, data, record, grid) => { },
        width: '330',
        countWidth: '6em',
        contextmenu: [
            {
                _button: '添加分类', icon: 'plus',
                handler: (that, data, record, grid) => {
                    Tyan.pubForm.showDialog('物料分类', props => <MaterialCategoryDiv {...props} id={0} onSave={that.refresh} />)
                },
            },
            {
                _button: '属性', icon: 'info',
                hidden: data => data.depth == 1,
                handler: (that, data, record, grid) => {
                    Tyan.pubForm.showDialog('物料分类', props => <MaterialCategoryDiv {...props} id={data.id} onSave={that.refresh} />)
                },
            },
        ],
    },

}

export default props => <Manager {...props} config={config} />